module.exports = __webpack_public_path__ + "img/slide_2.d569b81b.jpg";